import { AxiosError, isAxiosError } from "axios"

const AXIOS_NETWORK_ERROR_PREFIX = AxiosError.ERR_NETWORK

export const isAxiosNetworkError = (error: unknown) => {
	return (
		isAxiosError(error) &&
		typeof error.code === "string" &&
		error.code.startsWith(AXIOS_NETWORK_ERROR_PREFIX)
	)
}
